<template>
	<div class="row">
		<div class="col-12">
			<div class="box">
				<StallionNotes :horse_id="horse_id" />
			</div>
		</div>
		<div class="col-12 mt-2">
			<div class="box">
				<div class="row">
					<div class="col-6">
						<h2>{{ $t('monte.congelation.proprietaire_stallion') }}</h2>
						<div v-for="tiers in tiers_horse" :key="tiers.tiershorse_id" class="mb-2">
							{{ tiers.tiers.tiers_rs }}
						</div>
						<h2>{{ $t('horse.tiers_secondaires') }}</h2>
						<div v-for="tiers in secondaires" :key="tiers.tiershorse_id">
							{{ tiers.tiers.tiers_rs }} - {{ getTrad(tiers.fonction.fonction_label) }}
						</div>
					</div>
					<div class="col-6">
						<div class="d-flex align-items-center justify-content-between">
							<h2>{{ $t('monte.congelation.gestionnaires') }}</h2>
							<b-button variant="primary" @click="openGestionnaireModal()"><font-awesome-icon :icon="['fal', 'plus']" /></b-button>
						</div>
						<table class="table table-bordered w-100">
							<thead>
								<tr>
									<th>{{ $t('monte.congelation.gestionnaires') }}</th>
									<th>{{ $t('monte.congelation.en_gestion') }}</th>
									<th style="width: 1px; white-space: nowrap;"></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="g in gestionnaires" :key="g.tiersgestionnaire_id">
									<td>
										<router-link v-if="g.gestionnaire" :to="{ name: 'tiersFiche', params: { tiers_id: g.gestionnaire.tiers_id }}">{{ g.gestionnaire.tiers_rs }}</router-link>
									</td>
									<td>
										<template v-if="g.tiersgestionnaire_indivision">{{ $t('monte.congelation.indivision') }}</template>
										<router-link v-else-if="g.tiers" :to="{ name: 'tiersFiche', params: { tiers_id: g.tiers.tiers_id }}">{{ g.tiers.tiers_rs }}</router-link>
									</td>
									<td><b-button variant="secondary" @click="openGestionnaireModal(g)"><font-awesome-icon :icon="['far', 'pencil-alt']"/></b-button></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 mt-2">
			<div class="box">
				<StallionStocksNormes :horse_id="horse_id" />
			</div>
		</div>

		<ModalGestionnaire ref="modalGestionnaire" :horse_id="horse_id" @submit="loadGestionnaires" />
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"
    import Horse from "@/mixins/Horse.js"
    import Tiers from "@/mixins/Tiers.js"

	export default {
		name: 'StallionDashboard',
		mixins: [Congelation, Horse, Tiers],
		props: ['horse_id'],
		data () {
			return {
				loading: false,
				tiers_horse: [],
				secondaires: [],
				gestionnaires: []
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
				const tiers = await this.loadTiersHeavyCurrentPart(this.horse_id, true)
				this.tiers_horse = tiers.filter(tier => !tier.zero)
				this.secondaires = await this.loadTiersHorseSecondaires(this.horse_id)
				await this.loadGestionnaires()
				this.loading = false
			},

			async loadGestionnaires() {
				this.gestionnaires = await this.getStallionGestionnaires(this.horse_id)
			},

			formatMonth(month) {
				const split = month.split('_')
				return this.getTrad("mois."+parseInt(split[0], 10)) +" "+ split[1]
			},

			openGestionnaireModal(gestionnaire = null) {
				this.$refs.modalGestionnaire.show(gestionnaire)
			}
		},

		components: {
			StallionNotes: () => import('@/components/Congelation/StallionNotes'),
			StallionStocksNormes: () => import('@/components/Congelation/StallionStocksNormes'),
			ModalGestionnaire: () => import('@/components/Congelation/ModalGestionnaire')
		}
	}

</script>